import React, { useState } from "react";
import { intl } from "LocaleWrapper";
import { Button, FormGroup } from "@cofano/cck";
import { Popover } from "@mui/material";
import { AdminSettingsGroup, AdminSettingsPlugin } from "view/admin/utils/admin.types";

interface AdminSettingsChangesButtonProps {
	changes: {
		plugins: AdminSettingsPlugin[];
		fields: AdminSettingsGroup[];
	}
}

const AdminSettingsChangesButton = ({ changes }: AdminSettingsChangesButtonProps) => {

	const [ anchorEl, setAnchorEl ] = useState<HTMLButtonElement | null>(null);

	return (
		<React.Fragment>
			<Button
				variant='text'
				size='small'
				color='warning'
				onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
				onMouseLeave={() => setAnchorEl(null)}>
				<span>Changes...</span>
			</Button>

			<Popover
				id='mouse-over-popover'
				sx={{ pointerEvents: "none" }}
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
				onClose={() => setAnchorEl(null)}
				disableRestoreFocus>
				<div style={{ padding: 16, width: 500 }}>
					{changes.plugins.map((plugin) => (
						<FormGroup label={plugin.key} key={plugin.key} overflow='hidden'>
							{plugin.value}
						</FormGroup>
					))}

					{changes.fields.map((it) => {
						return (it.fields ?? []).map((field) => (
							<FormGroup
								label={`${it.name} - ${field.name}`}
								key={it.name}
								overflow='hidden'>
								<div>
									<div>{field.enabled ? "true" : "false"}</div>
									<div>
										{(field.accessUserTypes ?? [])
											.map((userType) => intl.formatMessage({ id: `USER_TYPE_${userType}` }))
											.join(", ")}
									</div>
								</div>
							</FormGroup>
						));
					})}
				</div>
			</Popover>
		</React.Fragment>
	);
};

export default AdminSettingsChangesButton;
